import { ExternalLink } from "lucide-react";

const CDN = "https://images.squarespace-cdn.com/content/v1/5efe5eb3e2b42d3ef73d0dc7/";
const STORE = "https://www.theimprovaneermethod.com/purchase/p/";

const MERCH = [
  { name: "IM Skills and Performance T-Shirt", price: "from $26.50", slug: "unisex-t-shirt", img: "1741212136839-KHL358UINCHRBKX0I24D/unisex-staple-t-shirt-black-front-67c8c9db851aa.jpg" },
  { name: "Unleash Your Big Dog T-Shirt", price: "from $30.00", slug: "unleash-your-big-dog-t-shirt", img: "1719151957471-1BJBALSYA5QSZQQJ6NJU/unisex-staple-t-shirt-black-front-66782d465d329.jpg" },
  { name: "Improvaneer Method Gift Card", price: "from $25.00", slug: "improvaneer-method-gift-card", img: "1609257065760-BDVJJ3ZNNX0HLNFWA11S/IM+Mountain+logo+high+res.png" },
  { name: "Unisex Zip Hoodie", price: "$50.00", slug: "unisex-zip-hoodie", img: "1639929584563-UEGC4UJBPCTI14LTAL08/unisex-lightweight-zip-hoodie-charcoal-black-triblend-front-61bf56ebe5c5d.jpg" },
  { name: "Unisex Hoodie", price: "from $48.00", slug: "unisex-hoodie-1", img: "1639929412000-1M2SM7NKF07TOKTCBAYH/unisex-pullover-hoodie-black-front-61bf563f1b4ff.jpg" },
  { name: "Youth Short Sleeve T-Shirt", price: "$20.00", slug: "youth-short-sleeve-t-shirt", img: "1639929276585-KBEKT56L5HUNN3Q5TEK9/youth-staple-tee-navy-front-61bf55b801b1d.jpg" },
  { name: "Women's Relaxed T-Shirt", price: "from $25.00", slug: "womens-relaxed-t-shirt-1", img: "1639928827820-30EHQO9ZVKI2OGYEWIOB/womens-relaxed-t-shirt-navy-front-61bf53f1d7629.jpg" },
  { name: "Short-Sleeve Unisex T-Shirt", price: "from $25.00", slug: "short-sleeve-unisex-t-shirt-1", img: "1639928342583-HMEX02OR5UGGUO5SNZRN/unisex-staple-t-shirt-navy-front-61bf5211ab761.jpg" },
  { name: "Unisex Hoodie (Classic)", price: "from $48.00", slug: "unisex-hoodie", img: "1639927668399-ZID50F06RIWWACOTQW7M/unisex-pullover-hoodie-black-front-61bf4f6fa0e6e.jpg" },
  { name: "Women's Relaxed T-Shirt (Poppy)", price: "$25.00", slug: "womens-relaxed-t-shirt", img: "1639927336441-N5UNM27AT865CZ99YR8B/womens-relaxed-t-shirt-poppy-front-61bf4e2392c6b.jpg" },
  { name: "Short-Sleeve Unisex T-Shirt (Staple)", price: "$25.00", slug: "short-sleeve-unisex-t-shirt", img: "1639926861548-Y792D17UBH4Y5YXXO19L/unisex-staple-t-shirt-navy-front-61bf4c496b637.jpg" },
];

export default function MerchGrid() {
  return (
    <div data-testid="merch-grid">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <span className="text-xs uppercase tracking-[0.22em] font-extrabold text-[#920e12]">Merchandise</span>
          <h2 className="mt-2 font-display text-3xl text-[#1a1617]">Wear the method</h2>
          <p className="mt-1 text-[#545454]">Tees, hoodies, and gift cards. Checkout is handled on our secure store.</p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {MERCH.map((m) => (
          <a key={m.slug} href={`${STORE}${m.slug}`} target="_blank" rel="noopener noreferrer"
            data-testid={`merch-${m.slug}`}
            className="group bg-white rounded-2xl border border-[#dfd8da] overflow-hidden hover:border-[#920e12] transition-colors duration-150">
            <div className="aspect-square bg-[#f2eeee] overflow-hidden">
              <img src={`${CDN}${m.img}`} alt={m.name} loading="lazy"
                className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-300" />
            </div>
            <div className="p-4">
              <h3 className="text-sm font-bold text-[#1a1617] leading-snug group-hover:text-[#920e12]">{m.name}</h3>
              <div className="mt-1 flex items-center justify-between">
                <span className="text-[#920e12] font-extrabold">{m.price}</span>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#545454] group-hover:text-[#920e12]">View <ExternalLink size={12} /></span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
